import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import { notifyChartBalanceRefresh } from "../../../utils/chartBalanceRefresh";
const CreditDebitPopup = ({
  userData,
  onChangeMode,
  displayMode,
  creditDebitObj
}) => {
  let username = "";
  let sponsor = "";
  let currency = "";
  let CashDepositTxt = "";
  let CashWithTxt = "";

  let cashDepositAmount = 0;
  let cashWithdrawalAmount = 0;

  let creditDepositAmount = 0;
  let creditWithdrawalAmount = 0;

  let CreditDepositTxt = "";
  let CreditWithTxt = "";

  //cashpopup
  let credit_amount_user = 0;
  let balance_cash = 0;
  let max_withdrawal_cash = 0;

  const navigate = useNavigate();

  //credit popup

  let credit_reference = 0;
  let credit_amount_user_credit = 0;

  const [cashDepositAmountDefault, setCashDepositAmountDefault] = useState(0);
  const [sponsorInfo, setSponsorInfo] = useState({});

  const [cashDepositDesc, setCashDepositDesc] = useState("");
  const [cashDepositAmt, setCashDepositAmount] = useState(0);

  const [cashWithDrawalDesc, setCashWithDrawalDesc] = useState("");
  const [cashWithdrawalAmt, setCashWithdrawalAmt] = useState(0);

  const [creditDepositDesc, setCreditDepositDesc] = useState("");
  const [creditDepositAmt, setCreditDepositAmount] = useState(0);

  const [creditWithdrawalDesc, setCreditWithdrawalDesc] = useState("");
  const [creditWithdrawalAmt, setCreditWithdrawalAmt] = useState(0);

  const [cashDisplayError, setCashDisplayError] = useState("");
  const [creditDisplayError, setCreditDisplayError] = useState("");

  const [disabledButton, setDisabledButton] = useState(false);

  const handleShowHideCash = async (mode) => {
    if (mode == "Cash") {
      onChangeMode("Cash");
      setCashDepositAmountDefault(0);
    }

    if (mode == "Credit") {
      onChangeMode("Credit");
      //creditDepositAmount = 0;
      //creditWithdrawalAmount = 0;
    }
  };

  if (userData !== "" && userData !== null && userData !== undefined) {
    username = userData.uname;
    sponsor = userData.sponsor;
    currency = userData.currency;

    let bz_balance = Number(userData.bz_balance);
    let user_role = Number(userData.user_role);
    if (user_role === 8) {
      balance_cash = bz_balance;
    } else {
      balance_cash = 0;
    }

    if (user_role == 8) {
      credit_amount_user = Number(userData.credit_amount);
      credit_amount_user_credit = Number(userData.bz_balance);
    } else {
      credit_amount_user = Number(userData.credit_amount);
      credit_amount_user_credit = Number(userData.credit_amount);
    }

    if (bz_balance < 0) {
      if (credit_amount_user == 0) {
        max_withdrawal_cash = 0;
      } else {
        max_withdrawal_cash = credit_amount_user + bz_balance;
      }
    } else {
      if (user_role == 8) {
        max_withdrawal_cash = bz_balance;
      } else {
        max_withdrawal_cash = credit_amount_user + bz_balance;
      }
    }

    //mastercredit_amount = userData.credit_amount;
    credit_reference = userData.credit_reference;

    if (currency === 1) {
      currency = "Rs";
    } else if (currency === 2) {
      currency = "PKR";
    } else if (currency === 3) {
      currency = "AED";
    } else if (currency === 4) {
      currency = "USD";
    }

    CashDepositTxt = creditDebitObj.CashDepositTxt;
    CashWithTxt = creditDebitObj.CashWithTxt;

    CreditDepositTxt = creditDebitObj.CreditDepositTxt;
    CreditWithTxt = creditDebitObj.CreditWithTxt;
  }

  // cash function start here
  const handelCashDepositDecription = (event) => {
    let txt = event.target.value;
    console.log(txt);
    setCashDepositDesc(txt);
  };

  const handelCashDepositAmount = (event) => {
    let amt = event.target.value;
    setCashDepositAmount(amt);
  };


  const handleCashDeposit = async () => {
    try {
      let obj = {};
      setCashDisplayError("");
      setDisabledButton(true);
      obj.amount = cashDepositAmt;
      if (cashDepositDesc == "") {
        obj.description = creditDebitObj.CashDepositTxt;
      } else {
        obj.description = cashDepositDesc;
      }
      obj.from_id = userData.sponser_id;
      obj.to_id = userData._id;
      obj.mode = "cash_deposit";

      //calling api here
      const response = await axiosInstance.post(
        "/company/user-deposit-popup",
        obj
      );

      // Wait 1 second after API confirmation to ensure backend completes all updates
      setTimeout(() => {
        notifyChartBalanceRefresh();
        navigate("/agent/popup-page/le/" + userData._id);
      }, 1000);
    } catch (err) {
      setDisabledButton(false);
      if (
        err.response.data !== "" &&
        err.response.data.M !== null &&
        err.response.data.M !== undefined
      ) {
        setCashDisplayError(err?.response?.data?.M);
      }
    }
  };

  const handelCashWithdrawalDecription = (event) => {
    let txt = event.target.value;
    setCashWithDrawalDesc(txt);
  };

  const handelCashWithdrawalAmount = (event) => {
    let amt = event.target.value;
    setCashWithdrawalAmt(amt);
  };

  //cash withdrawl method
  const handleCashWithdrawal = async () => {
    try {
      let obj = {};
      setCashDisplayError("");
      setDisabledButton(true);
      obj.amount = cashWithdrawalAmt;
      if (cashWithDrawalDesc == "") {
        obj.description = creditDebitObj.CashWithTxt;
      } else {
        obj.description = cashWithDrawalDesc;
      }
      obj.from_id = userData._id;
      obj.to_id = userData.sponser_id;
      obj.mode = "cash_withdrawal";
      const response = await axiosInstance.post(
        "/company/user-withdrawal-popup",
        obj
      );

      // Wait 1 second after API confirmation to ensure backend completes all updates
      setTimeout(() => {
        notifyChartBalanceRefresh();
        navigate("/agent/popup-page/le/" + userData._id);
      }, 1000);
      ///alert(response?.data?.M);
    } catch (err) {
      setDisabledButton(false);
      if (
        err.response.data !== "" &&
        err.response.data.M !== null &&
        err.response.data.M !== undefined
      ) {
        setCashDisplayError(err?.response?.data?.M);
      }
    }
  };

  // credit function start here
  const handelCreditepositDecription = (event) => {
    let txt = event.target.value;
    setCreditDepositDesc(txt);
  };

  const handelCreditepositAmount = (event) => {
    let txt = event.target.value;
    setCreditDepositAmount(txt);
  };

  const handleCreditDeposit = async () => {
    try {
      setDisabledButton(true);
      let obj = {};
      obj.amount = creditDepositAmt;
      if (creditDepositDesc == "") {
        obj.description = creditDebitObj.CreditDepositTxt;
      } else {
        obj.description = creditDepositDesc;
      }
      obj.from_id = userData.sponser_id;
      obj.to_id = userData._id;
      obj.mode = "credit_deposit";
      const response = await axiosInstance.post(
        "/company/user-credit-deposit-popup",
        obj
      );

      // Wait 1 second after API confirmation to ensure backend completes all updates
      setTimeout(() => {
        notifyChartBalanceRefresh();
        navigate("/agent/popup-page/crle/" + userData._id);
      }, 1000);

      //debugger;
    } catch (err) {
      setDisabledButton(false);
      if (
        err.response.data !== "" &&
        err.response.data.M !== null &&
        err.response.data.M !== undefined
      ) {
        setCreditDisplayError(err?.response?.data?.M);
      }
    }
  };

  const handelCreditWithdrawalDescription = (event) => {
    let txt = event.target.value;
    setCreditWithdrawalDesc(txt);
  };

  const handelCreditWithdrawalAmount = (event) => {
    let amt = event.target.value;
    setCreditWithdrawalAmt(amt);
  };

  const handleCreditWithdrawal = async () => {
    try {
      setDisabledButton(true);
      let obj = {};
      obj.amount = creditWithdrawalAmt;
      if (creditWithdrawalDesc == "") {
        obj.description = creditDebitObj.CreditWithTxt;
      } else {
        obj.description = creditWithdrawalDesc;
      }
      obj.from_id = userData._id;
      obj.to_id = userData.sponser_id;
      obj.mode = "credit_withdrawal";
      const response = await axiosInstance.post(
        "/company/user-credit-withdrawal-popup",
        obj
      );

      // Wait 1 second after API confirmation to ensure backend completes all updates
      setTimeout(() => {
        notifyChartBalanceRefresh();
        navigate("/agent/popup-page/crle/" + userData._id);
      }, 1000);

      //debugger;
    } catch (err) {
      setDisabledButton(false);
      if (
        err.response.data !== "" &&
        err.response.data.M !== null &&
        err.response.data.M !== undefined
      ) {
        setCreditDisplayError(err?.response?.data?.M);
      }
    }
  };

  useEffect(() => {
    const loadData = async () => {
      if (!userData) return;
      if (userData.sponser_id !== undefined) {
        const response = await axiosInstance.get(
          "user/user-info/" + userData.sponser_id
        );
        if (response.data != undefined && response.data !== null) {
          setSponsorInfo(response.data);
        }
      }
    };
    loadData();
  }, [userData]);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div
      className="container-fluid"
      style={{ padding: "0px 15px", background: "#ebebec" }}
    >
      <style>
        {`
                <style>
                    @media screen and (max-width: 635px) {
                        .editsbmtbtn {
                            margin: auto;
                            margin-top: -30px;
                            margin-right: 15px;
                            background: transparent;
                            border: none;
                        }
                    }
                    </style>`}
      </style>
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-12">
            <div
              className="card"
              style={{
                marginBottom: "0px",
                borderRadius: "0.25rem 0.25rem 0px 0px",
                border: "0px"
              }}
            >
              <div
                style={{
                  width: "90%",
                  background: "white",
                  marginLeft: "auto",
                  marginRight: "auto",
                  height: "15px",
                  marginTop: "0px",
                  marginBottom: "0px"
                }}
              ></div>
              <div className="card-body">
                <ul className="nav nav-pills nav-fill">
                  <li className="nav-item">
                    <a
                      class={
                        displayMode == "Cash" ? "nav-link active" : "nav-link"
                      }
                      href="#"
                      onClick={() => handleShowHideCash("Cash")}
                      style={{
                        padding: "1px",
                        background: displayMode == "Cash" ? "#027bff" : ""
                      }}
                    >
                      <b className="site_family">Cash</b>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      class={
                        displayMode == "Credit" ? "nav-link active" : "nav-link"
                      }
                      onClick={() => handleShowHideCash("Credit")}
                      style={{
                        padding: "1px",
                        background: displayMode == "Credit" ? "#027bff" : ""
                      }}
                      href="#"
                    >
                      <b className="site_family">Credit</b>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: displayMode == "Cash" ? "" : "none" }}>
          <div className="row">
            <div className="col-12">
              <div
                className="card"
                style={{
                  marginBottom: "7px",
                  borderRadius: "0px 0px 0.25rem 0.25rem",
                  border: "0px"
                }}
              >
                <div className="card-body">
                  <div
                    style={{
                      width: "90%",
                      background: "#eff0f2",
                      marginLeft: "auto",
                      marginRight: "auto",
                      height: "1px",
                      marginTop: "8px",
                      marginBottom: "8px"
                    }}
                  ></div>
                  <h5>
                    <strong className="site_family">{username}</strong>
                  </h5>

                  <div
                    class="alert alert-danger"
                    style={{ display: cashDisplayError != "" ? "" : "none" }}
                  >
                    <strong className="site_family">{cashDisplayError}</strong>
                  </div>

                  <table className="table table-sm table-bordered">
                    <tbody>
                      <tr>
                        <td className="site_family">Credit</td>
                        <td className="site_family">Balance</td>
                        <td className="site_family">Max Widthdraw</td>
                      </tr>
                      <tr style={{ background: "#ffffff" }}>
                        <th className="site_family">
                          {formatTruncate(credit_amount_user)} {currency}.
                        </th>
                        <th className="site_family">
                          {formatTruncate(balance_cash)} {currency}.
                        </th>
                        <th className="site_family">
                          {formatTruncate(max_withdrawal_cash)} {currency}.
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Cash Code Start Here*/}

          <div className="col-md-9" style={{ padding: "7px 16px 5px 16px" }}>
            <div className="card" style={{ marginBottom: "5px" }}>
              <div
                className="card-header text-white "
                style={{ background: "#06b281", fontWeight: "bold" }}
              >
                <strong className="site_family" style={{ fontWeight: "bold" }}>
                  Deposit
                </strong>{" "}
                Cash in{" "}
                <strong className="site_family" style={{ fontWeight: "bold" }}>
                  {username}
                </strong>{" "}
                Account
              </div>
              <div className="card-body">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label site_family">
                    Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      defaultValue={CashDepositTxt}
                      type="text"
                      className="form-control site_family"
                      onChange={handelCashDepositDecription}
                      style={{
                        fontSize: "1rem",
                        fontWeight: "400",
                        color: "#495057",
                        height: "calc(1.5em + .75rem + 2px)"
                      }}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-sm-3 col-form-label site_family"
                    for="text-input"
                  >
                    Amount
                  </label>
                  <div className="col-sm-9">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text site_family"
                          style={{ fontWeight: "bold", background: "#e9ebee" }}
                        >
                          {currency}.{" "}
                        </span>
                      </div>
                      <input
                        className="form-control site_family"
                        type="text"
                        style={{
                          fontSize: "1rem",
                          fontWeight: "400",
                          color: "#495057",
                          height: "calc(1.5em + .75rem + 2px)"
                        }}
                        defaultValue={cashDepositAmountDefault}
                        onChange={handelCashDepositAmount}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card-footer editsbmtbtn"
                style={{ textAlign: "right", background: "#ffffff" }}
              >
                <button
                  className="btn btn-primary btn-submit"
                  type="button"
                  disabled={disabledButton}
                  onClick={() => handleCashDeposit()}
                >
                  <strong className="site_family">Submit</strong>
                </button>
              </div>
            </div>
          </div>

          <div
            className="col-md-9"
            style={{ padding: "0px 16px", marginTop: "10px" }}
          >
            <div className="card">
              <div
                className="card-header text-white site_family"
                style={{ background: "#db3545", fontWeight: "bold" }}
              >
                <strong className="site_family" style={{ fontWeight: "bold" }}>
                  Withdraw
                </strong>{" "}
                Cash from{" "}
                <strong className="site_family" style={{ fontWeight: "bold" }}>
                  {username}
                </strong>{" "}
                Account
              </div>
              <div className="card-body">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label site_family">
                    Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      onChange={handelCashWithdrawalDecription}
                      defaultValue={CashWithTxt}
                      className="form-control site_family"
                      type="text"
                      style={{
                        fontSize: "1rem",
                        fontWeight: "400",
                        color: "#495057",
                        height: "calc(1.5em + .75rem + 2px)"
                      }}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-sm-3 col-form-label site_family"
                    for="text-input"
                  >
                    Amount
                  </label>
                  <div className="col-sm-9">
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        style={{
                          background: "#e9ecef",
                          border: "1px solid #ced4da",
                          color: "#495057",
                          borderRadius: ".25rem"
                        }}
                      >
                        <span
                          className="input-group-text site_family"
                          style={{ fontWeight: "bold", background: "#e9ebee" }}
                        >
                          {currency}.
                        </span>
                      </div>
                      <input
                        className="form-control site_family"
                        defaultValue={cashWithdrawalAmount}
                        type="text"
                        style={{
                          fontSize: "1rem",
                          fontWeight: "400",
                          color: "#495057",
                          height: "calc(1.5em + .75rem + 2px)"
                        }}
                        onChange={handelCashWithdrawalAmount}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card-footer editsbmtbtn"
                style={{ textAlign: "right", background: "#ffffff" }}
              >
                <button
                  className="btn btn-danger btn-submit"
                  type="button"
                  style={{ background: "#db3545" }}
                  disabled={disabledButton}
                  onClick={() => handleCashWithdrawal()}
                >
                  <strong className="site_family">Submit</strong>
                </button>
              </div>
            </div>
          </div>

          {/* Cash Code end Here*/}
        </div>

        {/* Credit Code Start Here*/}

        <div
          id="credit_mode"
          style={{ display: displayMode == "Credit" ? "" : "none" }}
        >
          <div className="row">
            <div className="col-12">
              <div
                className="card"
                style={{
                  marginBottom: "7px",
                  borderRadius: "0px 0px 0.25rem 0.25rem",
                  border: "0px"
                }}
              >
                <div className="card-body">
                  <div
                    style={{
                      width: "90%",
                      background: "#eff0f2",
                      marginLeft: "auto",
                      marginRight: "auto",
                      height: "1px",
                      marginTop: "8px",
                      marginBottom: "8px"
                    }}
                  ></div>
                  <h5>
                    <strong className="site_family">{username}</strong>
                  </h5>

                  <div
                    class="alert alert-danger"
                    style={{ display: creditDisplayError != "" ? "" : "none" }}
                  >
                    <strong className="site_family">
                      {creditDisplayError}
                    </strong>
                  </div>

                  <table className="table table-sm table-bordered">
                    <tbody>
                      <tr>
                        <td className="site_family">Credit limit</td>
                        <td className="site_family">{username} Credit</td>
                        <td className="site_family">
                          {username} Available Balance
                        </td>
                      </tr>
                      <tr style={{ background: "#ffffff" }}>
                        <th className="site_family">
                          {formatTruncate(sponsorInfo?.credit_amount)}{" "}
                          {currency}.{" "}
                        </th>
                        <th className="site_family">
                          {formatTruncate(credit_reference)} {currency}.{" "}
                        </th>
                        <th className="site_family">
                          {formatTruncate(credit_amount_user_credit)} {currency}
                          .{" "}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-9" style={{ padding: "7px 16px 4px 16px" }}>
            <form method="post" id="userdep_credit" name="userdep_credit">
              <div className="card" style={{ marginBottom: "5px" }}>
                <div
                  className="card-header text-white site_family"
                  style={{ background: "#06b281", fontWeight: "bold" }}
                >
                  <strong
                    className="site_family"
                    style={{ fontWeight: "bold" }}
                  >
                    Deposit
                  </strong>{" "}
                  Credit in{" "}
                  <strong
                    className="site_family"
                    style={{ fontWeight: "bold" }}
                  >
                    {username}
                  </strong>{" "}
                  Account
                </div>
                <div className="card-body">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label site_family">
                      Description
                    </label>
                    <div className="col-sm-9">
                      <input
                        defaultValue={CreditDepositTxt}
                        onChange={handelCreditepositDecription}
                        className="form-control site_family"
                        type="text"
                        style={{
                          fontSize: "1rem",
                          fontWeight: "400",
                          color: "#495057",
                          height: "calc(1.5em + .75rem + 2px)"
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-sm-3 col-form-label site_family"
                      for="text-input"
                    >
                      Amount
                    </label>
                    <div className="col-sm-9">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span
                            className="input-group-text site_family"
                            style={{
                              fontWeight: "bold",
                              background: "#e9ebee"
                            }}
                          >
                            {" "}
                            {currency}.{" "}
                          </span>
                        </div>
                        <input
                          className="form-control site_family"
                          type="text"
                          defaultValue={creditDepositAmount}
                          onChange={handelCreditepositAmount}
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card-footer editsbmtbtn"
                  style={{ textAlign: "right", background: "#ffffff" }}
                >
                  <button
                    className="btn btn-primary btn-submit site_family"
                    onClick={() => handleCreditDeposit()}
                    type="button"
                    disabled={disabledButton}
                  >
                    <strong>Submit</strong>
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div
            className="col-md-9"
            style={{ padding: "0px 16px", marginTop: "10px" }}
          >
            <div className="card">
              <div
                className="card-header text-white site_family"
                style={{ background: "#db3545", fontWeight: "bold" }}
              >
                <strong className="site_family">Withdraw</strong> Credit from{" "}
                <strong className="site_family">{username}</strong>
              </div>
              <div className="card-body">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label site_family">
                    Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      defaultValue={CreditWithTxt}
                      onChange={handelCreditWithdrawalDescription}
                      className="form-control site_family"
                      type="text"
                      style={{
                        fontSize: "1rem",
                        fontWeight: "400",
                        color: "#495057",
                        height: "calc(1.5em + .75rem + 2px)"
                      }}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-sm-3 col-form-label site_family"
                    for="text-input"
                  >
                    Amount
                  </label>
                  <div className="col-sm-9">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text site_family"
                          style={{ fontWeight: "bold", background: "#e9ebee" }}
                        >
                          {" "}
                          {currency}.{" "}
                        </span>
                      </div>
                      <input
                        className="form-control site_family"
                        type="text"
                        defaultValue={creditWithdrawalAmount}
                        onChange={handelCreditWithdrawalAmount}
                        style={{
                          fontSize: "1rem",
                          fontWeight: "400",
                          color: "#495057",
                          height: "calc(1.5em + .75rem + 2px)"
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card-footer editsbmtbtn"
                style={{ textAlign: "right", background: "#ffffff" }}
              >
                <button
                  style={{ background: "#db3545" }}
                  className="btn btn-danger btn-submit site_family"
                  onClick={() => handleCreditWithdrawal()}
                  disabled={disabledButton}
                >
                  <strong>Submit</strong>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Credit Code end Here*/}
      </div>
    </div>
  );
};

export default CreditDebitPopup;
